import { render, staticRenderFns } from "./PropertySelectMultipleColoredOption.vue?vue&type=template&id=43bb977c&"
import script from "./PropertySelectMultipleColoredOption.vue?vue&type=script&lang=js&"
export * from "./PropertySelectMultipleColoredOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.FFR503Cp8cB3/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43bb977c')) {
      api.createRecord('43bb977c', component.options)
    } else {
      api.reload('43bb977c', component.options)
    }
    module.hot.accept("./PropertySelectMultipleColoredOption.vue?vue&type=template&id=43bb977c&", function () {
      api.rerender('43bb977c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Properties/PropertySelectMultipleColoredOption.vue"
export default component.exports